export default {"src":"/_next/static/media/quotes.23caec1a.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};